import RootStore from './root-store';
import {
  action,
  computed,
  reaction,
} from 'mobx';

const WAIT_TIME_FOR_PROXY_RESPONSE = 2000;

class ProxyVersionStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.init();
  }

  get plantId(): number | null {
    return this.rootStore.locationsStore.plantId;
  }

  @computed
  get api() {
    return this.rootStore.newAuthStore;
  }

  init(): void {
    reaction(
      (): boolean => this.rootStore.batchStore?.isPacInitialCommandSent,
      (): void => {
        const { batchStore } = this.rootStore;
        batchStore.setTimeout(() => {
          if (batchStore.pacVersion) {
            const { pacVersion, proxyVersion, proxyIsOnline } = batchStore;
            const { firmware } = pacVersion;
            this.saveProxyData({
              proxyVersion,
              pacFirmwareVersion: firmware,
              proxyIsOnline,
            });
          }
        }, WAIT_TIME_FOR_PROXY_RESPONSE);
      },
    );
  }

  @action
    saveProxyData = (data: any): Promise<any> => {
      const { proxyVersion, pacFirmwareVersion, proxyIsOnline } = data;
      const url = `/api/plant/${this.plantId}/version`;
      return this.api
        .makeAuthorizedRequest(url,
          {
            proxyVersion,
            pacFirmwareVersion,
            proxyIsOnline,
          },
          'PUT');
    };

  @action
    getProxyData = (): Promise<any> => {
      return this.api
        .makeAuthorizedRequest(`/api/plant/${this.plantId}/version`);
    };
}

export default ProxyVersionStore;
